export default __webpack_public_path__ + "static/media/7.631430dd.png";